module.exports = __webpack_public_path__ + "img/new.217ba520.png";